import {
	PalletizerContext,
	RuntimeContext,
} from '../../context/PalletizerContext';
import { Dot } from '../General';
import { COLOR } from '../shared/shared';
import { PalletizerStatus } from 'libapi';
import React, { useContext } from 'react';

interface RunStatusProps {
	pWhiteText?: boolean;
}
export default function PalletizerRunStatusDisplay({
	pWhiteText,
}: RunStatusProps) {
	const lRuntimeContext = useContext(PalletizerContext) as RuntimeContext;
	const pStatus = lRuntimeContext.operational_state.status;
	const colorFromStatus = (pStatus: PalletizerStatus) => {
		switch (pStatus) {
			case PalletizerStatus.Homing:
			case PalletizerStatus.Running:
			case PalletizerStatus.Scanning:
			case PalletizerStatus.Testing:
				return COLOR.GREEN;
			case PalletizerStatus.Fault:
				return COLOR.RED;
			case PalletizerStatus.Offline:
				return COLOR.DARK_GREY;
			case PalletizerStatus.Freedrive:
				return COLOR.YELLOW;
			case PalletizerStatus.Ready:
			default:
				return COLOR.ELECTRIC_BLUE;
		}
	};
	const color = colorFromStatus(pStatus);

	return (
		<div className="flex-row align-center full-height double-margin-right">
			<Dot pSize={20} pColor={color} pShadowColor={color} />
			<div className="half-padding"></div>
			<span
				className={
					'font-5 half-padding-left ' + (!!pWhiteText ? ' color-white' : '')
				}
			>
				{pStatus}
			</span>
		</div>
	);
}
